(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var burger = $('[data-menu]');
  if (burger) burger.addEventListener('click', function () { document.body.classList.toggle('menu-open'); });

  // announcement rotator
  var ann = $('[data-ann]');
  if (ann) {
    var msgs = $$('.ann__i', ann), i = 0;
    $$('[data-ann-dir]', ann).forEach(function (b) {
      b.addEventListener('click', function () {
        msgs[i].classList.remove('is-on');
        i = (i + Number(b.dataset.annDir) + msgs.length) % msgs.length;
        msgs[i].classList.add('is-on');
      });
    });
  }

  // product rows
  $$('[data-row]').forEach(function (row) {
    var sc = $('[data-scroller]', row);
    $$('[data-dir]', row).forEach(function (btn) {
      btn.addEventListener('click', function () { sc.scrollBy({ left: Number(btn.dataset.dir) * sc.clientWidth * 0.8, behavior: 'smooth' }); });
    });
  });

  // collection: filter toggle, auto-submit, sort
  var col = $('[data-col]');
  if (col) {
    var ft = $('[data-filter-toggle]', col), form = $('[data-filter-form]', col);
    if (window.innerWidth < 900) { col.classList.add('is-closed'); ft.setAttribute('aria-expanded', 'false'); }
    ft.addEventListener('click', function () {
      var closed = col.classList.toggle('is-closed');
      ft.setAttribute('aria-expanded', String(!closed));
    });
    if (form) {
      form.addEventListener('change', function () { form.submit(); });
      var timer;
      $$('input[type=number]', form).forEach(function (n) {
        n.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { form.submit(); }, 800); });
      });
    }
    var st = $('[data-sort-toggle]', col), menu = $('[data-sort-menu]', col);
    if (st && menu) {
      st.addEventListener('click', function () {
        var open = menu.hidden;
        menu.hidden = !open;
        st.setAttribute('aria-expanded', String(open));
      });
      $$('[data-sort]', menu).forEach(function (b) {
        b.addEventListener('click', function () {
          if (form && form.elements.sort_by) { form.elements.sort_by.value = b.dataset.sort; form.submit(); }
          else { location.search = '?sort_by=' + encodeURIComponent(b.dataset.sort); }
        });
      });
    }
  }

  // wishlist (stored in this browser)
  var KEY = 'ricarda_wishlist';
  function getW() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function setW(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function paintW() {
    var w = getW();
    $$('[data-wish-count]').forEach(function (n) { n.textContent = w.length; });
    $$('[data-wish]').forEach(function (b) { var on = w.indexOf(b.dataset.wish) > -1; b.classList.toggle('on', on); b.setAttribute('aria-pressed', String(on)); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    var w = getW(), h = b.dataset.wish, k = w.indexOf(h);
    if (k > -1) w.splice(k, 1); else w.push(h);
    setW(w); paintW();
  });
  paintW();

  // size select + quick add
  document.addEventListener('click', function (e) {
    var sz = e.target.closest('.sz');
    if (sz && !sz.disabled) {
      var box = sz.closest('[data-sizes]');
      $$('.sz', box).forEach(function (s) { s.classList.remove('on'); });
      sz.classList.add('on');
      var add = $('[data-add]', box);
      add.dataset.variant = sz.dataset.variant; add.disabled = false; add.textContent = 'Add to bag';
      return;
    }
    var add2 = e.target.closest('[data-add]');
    if (add2 && add2.dataset.variant && !add2.disabled) {
      add2.disabled = true; var label = add2.textContent; add2.textContent = 'Adding';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(add2.dataset.variant), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error(); return fetch(root + 'cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (c) { $$('[data-bag-count]').forEach(function (n) { n.textContent = c.item_count; }); add2.textContent = 'Added'; })
        .catch(function () { add2.textContent = 'Unavailable'; })
        .then(function () { setTimeout(function () { add2.textContent = label; add2.disabled = false; }, 1600); });
    }
  });

  // password show/hide
  var pw = $('[data-pw]');
  if (pw) pw.addEventListener('click', function () {
    var inp = pw.parentNode.querySelector('input'), show = inp.type === 'password';
    inp.type = show ? 'text' : 'password'; pw.textContent = show ? 'Hide' : 'Show';
    pw.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
  });
})();

/* ---- v3: designs round 2 ---- */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }

  // modals
  function closeModals() { $$('.modal').forEach(function (m) { m.hidden = true; }); document.body.classList.remove('modal-open'); }
  function openModal(n) {
    var m = $('[data-modal="' + n + '"]'); if (!m) return;
    if (n === 'stores' && window.__fillStores) window.__fillStores();
    m.hidden = false; document.body.classList.add('modal-open');
  }
  window.__openModal = openModal;
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openModal(o.dataset.open); return; }
    if (e.target.closest('[data-close]') || (e.target.classList && e.target.classList.contains('modal'))) closeModals();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeModals(); closeSearch(); } });
  if (location.hash === '#pop-news') { var ok = $('[data-pop-ok]'); if (ok) ok.hidden = false; openModal('promo'); }

  // tile image sliders
  $$('[data-tile]').forEach(function (t) {
    var slides = $$('.tile__s', t), dots = $$('[data-dot]', t); if (dots.length < 2) return;
    var i = 0;
    function show(n) { i = n; slides.forEach(function (s, k) { s.classList.toggle('is-on', k === n); }); dots.forEach(function (d, k) { d.classList.toggle('on', k === n); }); }
    dots.forEach(function (d) { d.addEventListener('click', function () { show(Number(d.dataset.dot)); }); });
    setInterval(function () { show((i + 1) % slides.length); }, 5000);
  });

  // feature slider
  $$('[data-fs]').forEach(function (fs) {
    var sl = $$('[data-fs-slide]', fs), i = 0;
    $$('[data-fs-dir]', fs).forEach(function (b) {
      b.addEventListener('click', function () {
        sl[i].classList.remove('is-on'); i = (i + Number(b.dataset.fsDir) + sl.length) % sl.length; sl[i].classList.add('is-on');
      });
    });
  });

  // search panel
  var sp = $('[data-search]'), si = $('[data-search-input]'), res = $('[data-search-results]'), timer;
  function closeSearch() { if (sp) sp.hidden = true; }
  if (sp) {
    $$('[data-search-open]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); sp.hidden = !sp.hidden; if (!sp.hidden) si.focus(); }); });
    $('[data-search-close]').addEventListener('click', closeSearch);
    si.addEventListener('input', function () {
      clearTimeout(timer);
      var q = si.value.trim();
      if (q.length < 2) { res.hidden = true; return; }
      timer = setTimeout(function () {
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=5')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var r = d.resources.results, cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
            $('[data-search-cats]').innerHTML = (r.collections || []).map(function (c) { return '<li><a href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>'; }).join('');
            $('[data-search-products]').innerHTML = (r.products || []).map(function (p) {
              var img = p.image ? '<img src="' + esc(p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=300') + '" alt="">' : '';
              return '<article class="pc"><a class="pc__img" href="' + esc(p.url) + '">' + img + '</a><div class="pc__m"><span class="pc__v">' + esc(p.vendor) + '</span><a class="pc__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a><p class="pc__p">' + esc(Number(p.price).toLocaleString(undefined, { style: 'currency', currency: cur })) + ' ' + esc(cur) + '</p></div></article>';
            }).join('');
            var all = $('[data-search-all]'); all.textContent = "View all '" + q + "'"; all.href = root + 'search?q=' + encodeURIComponent(q) + '&type=product';
            res.hidden = false;
          }).catch(function () {});
      }, 250);
    });
  }

  // product page
  var pdp = $('[data-pdp]');
  if (pdp) {
    var vars = JSON.parse($('[data-variants]', pdp).textContent), idIn = $('[data-variant-id]', pdp), form = $('#pdp-form', pdp);
    var groups = $$('[data-opt-group]', pdp);
    var slides = $$('[data-g-slide]', pdp), thumbs = $$('[data-g-thumb]', pdp), gi = 0;
    var zimg = $('[data-zoom-img]'), zthumbs = $$('[data-z-thumb]');
    function go(n) {
      if (!slides.length) return; gi = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === gi); });
      thumbs.forEach(function (t, k) { t.classList.toggle('on', k === gi); });
    }
    function zoomTo(n) {
      gi = (n + slides.length) % slides.length; zimg.src = slides[gi].dataset.zoom;
      zthumbs.forEach(function (t, k) { t.classList.toggle('on', k === gi); }); go(gi);
    }
    $$('[data-g-dir]', pdp).forEach(function (b) { b.addEventListener('click', function () { go(gi + Number(b.dataset.gDir)); }); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.gThumb)); }); });
    slides.forEach(function (s) { s.addEventListener('click', function () { zoomTo(gi); openModal('zoom'); }); });
    $$('[data-z-dir]').forEach(function (b) { b.addEventListener('click', function () { zoomTo(gi + Number(b.dataset.zDir)); }); });
    zthumbs.forEach(function (t) { t.addEventListener('click', function () { zoomTo(Number(t.dataset.zThumb)); }); });
    go(0);

    function sel() { return groups.map(function (g) { var b = $('[aria-pressed=true]', g); return b ? b.dataset.val : null; }); }
    function find(s) { return vars.filter(function (v) { return v.options.every(function (o, i) { return s.length <= i || o === s[i]; }); })[0]; }
    function refresh() {
      var s = sel(), v = find(s);
      groups.forEach(function (g, k) { $$('[data-val]', g).forEach(function (b) { var t = s.slice(); t[k] = b.dataset.val; var m = find(t); b.classList.toggle('is-off', !(m && m.available)); }); });
      if (!v) return;
      idIn.value = v.id;
      $('[data-price]', pdp).innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s> <span>' + v.pct + '% off</span>' : '');
      var inst = $('[data-inst]', pdp); if (inst) inst.textContent = v.inst;
      var atc = $('[data-atc]', pdp); if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? 'Add to bag' : 'Sold out'; }
      $('[data-stock]', pdp).textContent = !v.available ? 'Sold out' : (v.inv !== null && v.inv > 0 && v.inv <= 3 ? 'Only ' + v.inv + ' left' : '');
      if (v.img >= 0) go(v.img);
      if (history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
    }
    groups.forEach(function (g) {
      $$('[data-val]', g).forEach(function (b) { b.addEventListener('click', function () {
        $$('[data-val]', g).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); }); refresh();
      }); });
    });
    if (groups.length) refresh();

    window.__fillStores = function () {
      var id = idIn.value, sz = '';
      groups.forEach(function (g) { if (g.dataset.name.indexOf('size') > -1) sz = $('[aria-pressed=true]', g).dataset.val; });
      $$('[data-stores]').forEach(function (d) { d.hidden = d.dataset.stores !== id; });
      $('[data-stores-intro]').textContent = 'This ' + pdp.dataset.title + (sz ? ' in size ' + sz : '') + ' is available at the following locations.';
    };

    if (form) form.addEventListener('submit', function (e) {
      var atc = $('[data-atc]', pdp); if (!atc) return;
      e.preventDefault(); atc.disabled = true; atc.textContent = 'Adding';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error(); return fetch(root + 'cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (c) { $$('[data-bag-count]').forEach(function (n) { n.textContent = c.item_count; }); atc.textContent = 'Added'; })
        .catch(function () { atc.textContent = 'Unavailable'; })
        .then(function () { setTimeout(function () { atc.disabled = false; atc.textContent = 'Add to bag'; }, 1600); });
    });
  }
})();
